import { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import {
  HubRoutes,
  CommunityRoutes,
  EventRegistrationRoutes,
  EventNotificationRoutes,
  StochasticRoutes,
  PartnerNetworkRoutes,
  AdminRoutes,
  CoachingRoutes,
  EmailManagementRoutes,
  LearningCenterRoutes,
  TrainingSystemRoutes,
  TranscriptRoutes,
  GameRoutes,
  ReportsRoutes,
  SalesCoachingRoutes,
  CallIntelligenceRoutes,
  TranscriptionQueueRoutes,
  CapExRoutes,
  SalesRoutes,
  ProductStorefrontRoutes,
  GrowthStagesRoutes,
} from "./routes";
import LoadingIndicator from "@/components/LoadingIndicator/LoadingIndicator";

// Lazy load rarely-used components
const TermsOfService = lazy(() =>
  import("../components/TermsOfService/TermsOfService").then((module) => ({
    default: module.TermsOfService,
  })),
);
const Logout = lazy(
  () => import("../modules/hub/features/Auth/components/Logout/Logout"),
);
const ForbiddenPage = lazy(
  () =>
    import(
      "@/modules/hub/features/Auth/components/ForbiddenPage/ForbiddenPage"
    ),
);
const MerryChristmasVara = lazy(() => import("@/pages/MerryChristmasVara"));

function AppRoutes() {
  return (
    <Suspense fallback={<LoadingIndicator />}>
      <Routes>
        <Route element={<Navigate replace to="/hub" />} path="/" />

        <Route
          element={<Navigate replace to="/certain-path/coaches-dashboard" />}
          path="/certain-path"
        />

        <Route
          element={<TermsOfService />}
          path="/certain-path/terms-of-service"
        />

        <Route element={<ForbiddenPage />} path="/403" />

        {/* Test page for Vara handwriting animation */}
        <Route element={<MerryChristmasVara />} path="/merry-christmas" />

        {HubRoutes}
        {CommunityRoutes}
        {EventRegistrationRoutes}
        {EventNotificationRoutes}
        {StochasticRoutes}
        {PartnerNetworkRoutes}
        {AdminRoutes}
        {CoachingRoutes}
        {EmailManagementRoutes}
        {LearningCenterRoutes}
        {TrainingSystemRoutes}
        {TranscriptRoutes}
        {GameRoutes}
        {ReportsRoutes}
        {SalesCoachingRoutes}
        {CallIntelligenceRoutes}
        {TranscriptionQueueRoutes}
        {CapExRoutes}
        {SalesRoutes}
        {ProductStorefrontRoutes}
        {GrowthStagesRoutes}
        <Route element={<Logout />} path="/logout" />
      </Routes>
    </Suspense>
  );
}

export default AppRoutes;
